export default __webpack_public_path__ + "static/media/patterns-no-7.a4d4b4e7.mid";